import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n from '../i18n';

const LanguageContext = createContext();

export const translations = {
    tr: {
        sensorDetail: {
            header: "Gelişmiş Analiz Paneli",
            sensor: "Sensör",
            returnMap: "HARİTAYA DÖN",
            location: "KONUM KOORDİNATLARI",
            airTemp: "Hava Sıcaklığı",
            airHumidity: "Hava Nemi",
            soilTemp: "Toprak Sıcaklığı",
            soilMoisture: "Toprak Nemi",
            rain: "YAĞIŞ",
            sensorSource: "SENSÖR",
            meteoSource: "METEOROLOJİ",
            analysisCompatible: "ANALİZ UYUMLU",
            chartTitle: "Zaman Serisi Analizi",
            dataSource: "VERİ KAYNAĞI: SENSÖR",
            interval: "HER 15 DK",
            dataRecords: "Veri Kayıtları",
            searchPlaceholder: "Ölçümlerde ara...",
            dateRange: "ARALIK:",
            exportCSV: "VERİLERİ DIŞA AKTAR (.CSV)",
            downloadNoData: "İndirilecek veri yok!",
            table: {
                date: "Tarih",
                time: "Saat",
                airTempMet: "Hava Sıc. / Met.",
                airHumMet: "Hava Nem / Met.",
                soilTempMet: "Toprak Sıc. / Met.",
                soilHumMet: "T. Nemi / Met.",
                status: "Durum",
                rain: "Yağış",
                clear: "Açık"
            },
            pagination: {
                prev: "ÖNCEKİ",
                next: "SONRAKİ",
                page: "SAYFA"
            },
            loading: "Veriler yükleniyor...",
            notFound: {
                title: "Sensör Bulunamadı",
                message: "Aranan ID:",
                check: "Lütfen sensör bağlantısını veya ID numarasını kontrol edin."
            },
            noData: {
                title: "Henüz Veri Yok",
                message: "veritabanında kayıtlı fakat henüz herhangi bir ölçüm verisi (sıcaklık, nem vb.) iletilmedi.",
                check: "Sensörün güç bağlantısı ve internet erişimini kontrol ediniz.",
                recordExists: "VERİ TABANI KAYDI MEVCUT"
            },
            chart: {
                airTemp: "Hava Sıcaklık (°C)",
                airHum: "Hava Nem (%)",
                soilTemp: "Toprak Sıcaklık (°C)",
                soilHum: "Toprak Nem (%)",
                dateRange: "Grafik Tarih Aralığı:",
                selectDateRange: "Tarih aralığı seçin",
                last10Days: "Son 10 Gün (Günlük Ort.)",
                dailyAverage: "Günlük Ortalama",
                meteorologicalData: "Meteorolojik Veriler",
                sensorData: "Sensör Verileri",
                resetToDefault: "Varsayılana Dön",
                noDataInRange: "Seçili tarih aralığında veri yok",
                timeRange: "Saat Aralığı:",
                startTime: "Başlangıç Saati",
                endTime: "Bitiş Saati",
                allDay: "Tüm Gün",
                combinedData: "Sensör ve Meteoroloji Verileri"
            },
        },
        sidebar: {
            overview: "Genel Bakış",
            map: "Harita",
            analysis: "Analiz",
            risk_analysis: "Risk Analizi",
            user_management: "Kullanıcı Yönetimi",
            support: "Destek / Mesajlar",
            profile: "Profilim"
        },
        header: {
            new_field: "Yeni Tarla Oluştur",
            logout: "Çıkış Yap",
            profile_info: "Profil Bilgilerim",
            change_password: "Şifre Değiştir",
            admin: "YÖNETİCİ",
            user: "KULLANICI"
        },
        dashboard: {
            my_fields: "Tarlalarım",
            field_count: "tarla",
            search_placeholder: "Tarla, ürün veya sahip ara...",
            welcome: "Hoş Geldiniz!",
            total_fields: "Toplam Tarla",
            total_area: "Toplam Alan (ha)",
            satellite_type: "Uydu Tipi",
            refresh_images: "Görüntüleri Yenile",
            no_fields: "Henüz tarla eklenmemiş",
            no_match: "Eşleşen tarla bulunamadı",
            start_hint: "Başlamak için \"Yeni Tarla Oluştur\" butonuna tıklayın",
            quick_actions: "Hızlı İşlemler",
            search_images: "Görüntü Ara",
            ndvi_analysis: "NDVI Analizi Yap",
            refresh_analysis: "Analizi Yenile (Kar Dahil)",
            confirm_refresh: "Bu tarlanın analiz verileri silinip tekrar hesaplanacak (Kar/Buz dahil). Onaylıyor musunuz?",
            first_search_hint: "Önce 'Görüntü Ara' butonuna tıklayın",
            start_analysis: "Analizi Başlat",
            mapMode: {
                title: "Harita modu açıldı!",
                instructions: "Yeni tarla oluşturmak için:\n1. Haritanın sağ üst köşesindeki çizim araçlarını (Polygon veya Rectangle) kullanın.\n2. Tarlanızın sınırlarını harita üzerinde çizin."
            }
        },
        field: {
            crop: "Ürün",
            owner: "Sahibi",
            planting: "Ekim",
            planting_date: "Ekim Tarihi",
            area: "Alan",
            delete: "Tarlayı Sil",
            not_specified: "Belirtilmemiş"
        },
        timeline: {
            loading: "NDVI verileri yükleniyor...",
            error: "NDVI zaman serisi yüklenirken hata oluştu",
            retry: "Tekrar Dene",
            average: "Ortalama",
            min: "Min",
            max: "Max",
            cloud_cover: "Bulutluluk",
            time_series: "Zaman Serisi",
            analysis_count: "Analiz Sayısı",
            last_value: "Son",
            no_analysis_yet: "Bu tarla için henüz {{index}} analizi yapılmamış",
            run_analysis_first: "Önce \"NDVI Analizi Yap\" butonuna tıklayın"
        },
        map: {
            add_sensor: "Sensör Ekle",
            edit_field: "Tarla Düzenle",
            edit_info: "Bilgileri Düzenle",
            coordinate: "Koordinat",
            instant_value: "Anlık",
            analysis: "Gelişim Analizi",
            analysis_date: "Analiz Tarihi",
            average: "Ortalama",
            edit_active: "Tarla düzenleme aktif! Köşeleri sürükleyin. Bitirdiğinizde tekrar butona basın.",
            changes_saved: "Değişiklikler kaydedildi!",
            field_name_required: "Tarla adı boş olamaz.",
            field_updated: "Tarla bilgileri güncellendi.",
            update_error: "Güncelleme sırasında hata oluştu.",
            drawing_error: "Çizim sırasında hata oluştu"
        },
        sensor: {
            system_active: "SİSTEM AKTİF",
            sensor: "Sensör",
            temperature: "SICAKLIK",
            humidity: "NEM",
            soil_moisture: "TOPRAK NEMİ",
            last_sync: "Son Senkronizasyon",
            open_details: "DETAYLI ANALİZİ AÇ"
        },
        common: {
            loading: "Yükleniyor...",
            error: "Hata",
            success: "Başarılı",
            cancel: "İptal",
            save: "Kaydet",
            confirm: "Onayla"
        },
        alerts: {
            map_mode_opened: "🗺️ Harita modu açıldı!\n\n🆕 Yeni tarla oluşturmak için:\n1. Haritanın sağ üst köşesindeki çizim araçlarını (Polygon veya Rectangle) kullanın.\n2. Tarlanızın sınırlarını harita üzerinde çizin.",
            field_created: "Tarla başarıyla oluşturuldu!",
            field_create_error: "Tarla oluşturulurken hata:",
            select_field_first: "Lütfen önce bir tarla seçin!",
            no_images_found: "Seçili alan için son 1 yıla ait bulutsuz Sentinel-2 görüntüsü bulunamadı.",
            images_saved: "Görüntüler hafızaya alındı. \"NDVI Analizi Yap\" butonuna tıklayarak işlemi başlatabilirsiniz.",
            analysis_complete: "Analiz Tamamlandı!",
            analysis_error: "NDVI analiz hatası:",
            image_search: {
                scanning: "Sentinel-2 Uydusu Taranıyor...",
                location: "Konum",
                duration: "Süre",
                duration_text: "Son 1 Yıl",
                found: "TOPLAM {{count}} GÖRÜNTÜ BULUNDU.",
                newest: "En yeni",
                oldest: "En eski",
                start_analysis: "NDVI Analizi yapılsın mı?",
                no_images: "Seçili alan için son 1 yıla ait bulutsuz Sentinel-2 görüntüsü bulunamadı.",
                please_search_first: "Lütfen önce \"Görüntü Ara\" butonuna basarak Sentinel-2 görüntülerini bulunuz!",
                analysis_success: "Analiz Tamamlandı!",
                analysis_details: "🛰️ Sentinel-2 L2A (SCL Bulut Maskeleme Uygulandı)\n📅 İşlenen Görüntü: {{count}} adet\n📊 Son Veri: {{date}}\n📈 Ortalama NDVI: {{ndvi}}\n📈 Ortalama NDRE: {{ndre}}\n\nAnaliz verileri SCL (Scene Classification) algoritması ile temizlenmiş ve bulutlu pikseller filtrelenmiştir.",
                no_meaningful_data: "Analiz işlemi tamamlandı ancak görüntülerden anlamlı NDVI verisi üretilemedi veya GEE sunucuları yanıt vermedi.\n\nDaha yakın tarihli veya bulutsuz bir tarih aralığı seçmeyi deneyebilirsiniz.",
                analysis_refreshed: "✅ Analiz yenilendi! Kar/Buz verileri dahil edildi.",
                refresh_error: "Yenileme hatası",
                search_error: "Görüntü arama hatası",
                contact_admin: "Lütfen tekrar deneyiniz veya sistem yöneticisine danışınız."
            }
        },
        ndvi: {
            bare_soil: "Çıplak toprak",
            sparse_vegetation: "Seyrek bitki",
            medium_density: "Orta yoğunluk",
            dense_vegetation: "Yoğun bitki",
            use_ndre: "NDRE kullanın",
            no_data: "Veri Yok",
            unknown: "Bilinmiyor"
        },
        ndmi: {
            critical_stress: "Kritik stres",
            high_stress: "Yüksek stres",
            medium_stress: "Orta stres",
            attention: "Dikkat",
            light_stress: "Hafif stres",
            normal: "Normal",
            good: "İyi",
            very_good: "Çok iyi",
            high_moisture: "Yüksek nem",
            no_data: "Veri Yok",
            unknown: "Bilinmiyor"
        },
        field_details: {
            title: "Tarla Detayları",
            field_name: "Tarla İsmi",
            area_label: "Yüzölçümü",
            hectare: "Hektar",
            planting_date: "Ekim Tarihi",
            not_specified: "Belirtilmemiş",
            current_status: "Mevcut Durum",
            last_data_date: "Son Veri Tarihi",
            avg_ndvi: "Ort. NDVI",
            avg_ndmi: "Ort. NDMI",
            avg_ndre: "Ort. NDRE",
            min_value: "Min Değer",
            max_value: "Max Değer"
        },
        weather: {
            humidity: "Nem",
            wind: "Rüzgar",
            loading: "Hava durumu yükleniyor...",
            clear: "Açık",
            partly_cloudy: "Az Bulutlu",
            cloudy: "Parçalı Bulutlu",
            overcast: "Bulutlu",
            fog: "Sisli",
            freezing_fog: "Dondurucu Sis",
            light_drizzle: "Hafif Çiseliyor",
            light_rain: "Hafif Yağmur",
            rain: "Yağmur",
            heavy_rain: "Şiddetli Yağmur",
            light_snow: "Hafif Kar",
            snow: "Kar",
            heavy_snow: "Yoğun Kar",
            storm: "Fırtına",
            unknown: "Bilinmiyor"
        },
        risk_analysis: {
            loading: "Risk analizi yapılıyor...",
            title: "Risk Analizi ve Öneriler",
            detected_issues: "Tespit Edilen Durumlar",
            no_risk: "Herhangi bir risk tespit edilmedi.",
            recommendations: "Öneriler",
            detailed_stats: "Detaylı İstatistikler",
            total_analysis: "Toplam Analiz",
            average: "Ortalama",
            monitoring_period: "İzleme Süresi",
            days: "gün",
            area: "Alan",
            data_missing: "Veri Eksikliği",
            no_analysis_for_field: "Bu tarla için henüz {{index}} analizi yapılmamış.",
            start_with_ndvi: "NDVI analizi yaparak başlayın",
            critical_loss: "Kritik {{index}} Kaybı",
            sharp_decline: "{{index}} değerinde son dönemde sert bir düşüş görüldü.",
            mild_regression: "Hafif Gelişim Gerilemesi",
            mild_slowdown: "İndeks değerinde hafif bir yavaşlama tespit edildi (Trend: {{trend}}).",
            positive_trend: "Pozitif Gelişim Trendi",
            growth_increasing: "Gelişim düzenli bir artış gösteriyor (+{{trend}}).",
            water_stress: "Su Stresi Tespit Edildi",
            water_stress_desc: "NDMI: {{value}} - Bitkilerde su stresi veya kuraklık riski mevcut.",
            attention_mild_stress: "Dikkat / Hafif Stres",
            mild_stress_desc: "NDMI: {{value}} - Nem seviyesi sınırda, hafif stres belirtileri olabilir.",
            ideal_moisture: "İdeal Nem / İyi Durum",
            ideal_moisture_desc: "NDMI: {{value}} - Bitkiler yeterli neme sahip, gelişim sağlıklı.",
            very_low_biomass: "Çok Düşük Biyokütle",
            low_biomass_desc: "{{index}}: {{value}} - Alanın büyük kısmında bitki örtüsü bulunmuyor.",
            early_growth: "Erken Gelişim / Düşük Yoğunluk",
            early_growth_desc: "{{index}}: {{value}} - Bitki örtüsü henüz kanopi kapanışına ulaşmamış.",
            dense_canopy: "Yoğun ve Sağlıklı Kanopi",
            dense_canopy_desc: "{{index}}: {{value}} - Maksimum fotosentetik aktivite gözlemleniyor.",
            low_homogeneity: "Düşük Homojenlik",
            low_homogeneity_desc: "Tarla içerisinde gelişim/nem farkları yüksek. Lokalize müdahale gerekebilir.",
            analysis_error: "Analiz Yapılamadı",
            analysis_error_desc: "Risk analizi yapılırken bir hata oluştu.",
            rec_soil_moisture_loss: "Toprak nem kaybı çok hızlı: Sulama programını acilen gözden geçirin.",
            rec_heat_stress: "Sıcaklık stresi: Buharlaşma kaybını azaltmak için malçlama veya gölgeleme düşünün.",
            rec_field_inspection: "Acil saha denetimi: Hastalık veya zararlı baskısı olabilir.",
            rec_leaf_analysis: "Yaprak analizi: Besin elementi noksanlığı ihtimalini değerlendirin.",
            rec_monitor_moisture: "Toprak nem seviyesini ve sulama sıklığını takip edin.",
            rec_continue_maintenance: "Bakım programına planlandığı gibi devam edin.",
            rec_check_irrigation: "Sulama sistemini kontrol edin; acil sulama gerekebilir.",
            rec_monitor_closely: "Nem seviyesini yakından takip edin.",
            rec_continue_irrigation: "Mevcut sulama programına devam edebilirsiniz.",
            rec_check_emergence: "Tohum çıkış başarısını (emergence) kontrol edin.",
            rec_weed_competition: "Yabancı ot rekabetini izleyin.",
            rec_drainage: "Drenaj veya toprak yapısındaki heterojenliği kontrol edin."
        },
        ai: {
            title: "AI Tarım Danışmanı",
            description: "Ürüne özel bilgi bankası ve uydu verilerini kullanarak yapay zeka destekli analiz ve öneriler alın.",
            analyze_button: "Analizi Başlat",
            analyzing: "Yapay zeka analiz yapıyor...",
            analyzing_hint: "Bu işlem birkaç saniye sürebilir",
            retry: "Tekrar Dene",
            reanalyze: "Yeniden Analiz Et",
            analysis_failed: "Analiz yapılamadı. Lütfen tekrar deneyin.",
            missing_data: "Tarla veya analiz verisi eksik.",
            knowledge_used: "Kullanılan bilgi bankası",
            open_advisor: "AI Danışman"
        },
        fieldMap: {
            modal: {
                newFieldTitle: "Yeni Tarla Kaydet",
                fieldName: "Tarla Adı",
                namePlaceholder: "Örn: Kuzey Parsel",
                cropType: "Ürün Çeşidi",
                cropPlaceholder: "Örn: Buğday, Mısır...",
                plantingDate: "Ekim Tarihi",
                assignUser: "Kullanıcı Ata (Admin)",
                assignSelf: "Kendime Ata",
                cancel: "İptal",
                save: "Kaydet",
                editFieldTitle: "Tarlayı Düzenle",
                fieldResponsible: "Tarla Sorumlusu (Aktar)",
                myself: "Kendim",
                close: "Kapat",
                update: "Güncelle"
            }
        },
        ndmiLegend: {
            title: "NDMI Değer Açıklaması",
            critical: "Kritik",
            highStress: "Yüksek Stres",
            mediumStress: "Orta Stres",
            attention: "Dikkat",
            lightStress: "Hafif Stres",
            normal: "Normal",
            good: "İyi",
            veryGood: "Çok İyi",
            moist: "Nemli"
        },
        ndviLegend: {
            title: "NDVI Değer Açıklaması",
            bareSoil: "Çıplak Toprak / Su",
            weakVegetation: "Zayıf Bitki Örtüsü",
            mediumVegetation: "Orta Düzey Bitki",
            healthyVegetation: "Sağlıklı Bitki",
            veryHealthyVegetation: "Çok Sağlıklı Bitki"
        },
        trendAnalysis: {
            title: "Trend Analizi",
            firstMeasurement: "İlk Ölçüm",
            lastMeasurement: "Son Ölçüm",
            change: "Değişim",
            significantImprovement: "Bitki sağlığında önemli iyileşme",
            stableHealth: "Bitki sağlığı stabil",
            slightDecline: "Hafif düşüş - İzleme önerilir",
            significantDecline: "Önemli düşüş - Müdahale gerekebilir"
        },
        sensorModal: {
            title: "Sensör Seçimi",
            singleSensor: "Tek Sensör",
            batchAdd: "Toplu Ekle",
            selectSensorToUpdate: "Konumunu güncellemek istediğiniz sensörü seçin:",
            selectSensorPlaceholder: "Sensör seçiniz...",
            targetField: "Hedef Tarla:",
            selectFieldFirst: "Lütfen önce bir tarla seçin!",
            selectSensorsToAdd: "Eklemek istediğiniz sensörleri işaretleyin:",
            selectAll: "Tümünü Seç",
            clear: "Temizle",
            addToField: "Sensörü Tarlaya Ekle",
            noSensorsAvailable: "Kullanılabilir sensör bulunamadı."
        },
        loadingOverlay: {
            processing: "İşlem yapılıyor..."
        },
        report: {
            title: "TARLA ANALİZ RAPORU",
            generate: "Rapor Hazırla",
            generating: "Rapor Hazırlanıyor...",
            date: "Tarih",
            area: "Alan",
            hectares: "hektar",
            fieldInfo: "TARLA BİLGİLERİ",
            cropType: "Ürün Tipi",
            location: "Konum",
            analysis: "ANALİZİ",
            latestValue: "Son Değer",
            min: "Min",
            max: "Maks",
            aiAnalysis: "AI ANALİZ VE ÖNERİLER"
        }
    },
    en: {
        sensorDetail: {
            header: "Advanced Analysis Panel",
            sensor: "Sensor",
            returnMap: "RETURN TO MAP",
            location: "LOCATION COORDINATES",
            airTemp: "Air Temperature",
            airHumidity: "Air Humidity",
            soilTemp: "Soil Temperature",
            soilMoisture: "Soil Moisture",
            rain: "PRECIPITATION",
            sensorSource: "SENSOR",
            meteoSource: "METEOROLOGY",
            analysisCompatible: "ANALYSIS COMPATIBLE",
            chartTitle: "Time Series Analysis",
            dataSource: "DATA SOURCE: SENSOR",
            interval: "EVERY 15 MIN",
            dataRecords: "Data Records",
            searchPlaceholder: "Search measurements...",
            dateRange: "RANGE:",
            exportCSV: "EXPORT DATA (.CSV)",
            downloadNoData: "No data to download!",
            table: {
                date: "Date",
                time: "Time",
                airTempMet: "Air Temp / Met.",
                airHumMet: "Air Hum / Met.",
                soilTempMet: "Soil Temp / Met.",
                soilHumMet: "Soil Hum / Met.",
                status: "Status",
                rain: "Rain",
                clear: "Clear"
            },
            pagination: {
                prev: "PREVIOUS",
                next: "NEXT",
                page: "PAGE"
            },
            loading: "Loading data...",
            notFound: {
                title: "Sensor Not Found",
                message: "Searched ID:",
                check: "Please check the sensor connection or ID number."
            },
            noData: {
                title: "No Data Yet",
                message: "is registered in the database but no measurement data (temperature, humidity, etc.) has been received yet.",
                check: "Check the sensor's power connection and internet access.",
                recordExists: "DATABASE RECORD EXISTS"
            },
            chart: {
                airTemp: "Air Temp (°C)",
                airHum: "Air Hum (%)",
                soilTemp: "Soil Temp (°C)",
                soilHum: "Soil Moist (%)",
                dateRange: "Chart Date Range:",
                selectDateRange: "Select date range",
                last10Days: "Last 10 Days (Daily Avg.)",
                dailyAverage: "Daily Average",
                meteorologicalData: "Meteorological Data",
                sensorData: "Sensor Data",
                resetToDefault: "Reset to Default",
                noDataInRange: "No data in selected date range",
                timeRange: "Time Range:",
                startTime: "Start Time",
                endTime: "End Time",
                allDay: "All Day",
                combinedData: "Sensor and Meteorological Data"
            },
        },
        sidebar: {
            overview: "Overview",
            map: "Map",
            analysis: "Analysis",
            risk_analysis: "Risk Analysis",
            user_management: "User Management",
            support: "Support / Messages",
            profile: "My Profile"
        },
        header: {
            new_field: "Create New Field",
            logout: "Logout",
            profile_info: "Profile Information",
            change_password: "Change Password",
            admin: "ADMIN",
            user: "USER"
        },
        dashboard: {
            my_fields: "My Fields",
            field_count: "fields",
            search_placeholder: "Search field, crop or owner...",
            welcome: "Welcome!",
            total_fields: "Total Fields",
            total_area: "Total Area (ha)",
            satellite_type: "Satellite Type",
            refresh_images: "Refresh Images",
            no_fields: "No fields added yet",
            no_match: "No matching fields found",
            start_hint: "Click \"Create New Field\" button to get started",
            quick_actions: "Quick Actions",
            search_images: "Search Images",
            ndvi_analysis: "Run NDVI Analysis",
            refresh_analysis: "Refresh Analysis (Inc. Snow)",
            confirm_refresh: "Analysis data for this field will be deleted and re-calculated (including Snow/Ice). Confirm?",
            first_search_hint: "Click 'Search Images' first",
            start_analysis: "Start Analysis",
            mapMode: {
                title: "Map mode opened!",
                instructions: "To create a new field:\n1. Use the drawing tools (Polygon or Rectangle) in the top right corner of the map.\n2. Draw your field boundaries on the map."
            }
        },
        field: {
            crop: "Crop",
            owner: "Owner",
            planting: "Planting",
            planting_date: "Planting Date",
            area: "Area",
            delete: "Delete Field",
            not_specified: "Not specified"
        },
        timeline: {
            loading: "Loading NDVI data...",
            error: "Error loading NDVI time series",
            retry: "Retry",
            average: "Average",
            min: "Min",
            max: "Max",
            cloud_cover: "Cloud Cover",
            time_series: "Time Series",
            analysis_count: "Analysis Count",
            last_value: "Last",
            no_analysis_yet: "No {{index}} analysis has been performed for this field yet",
            run_analysis_first: "Click \"Run NDVI Analysis\" button first"
        },
        map: {
            add_sensor: "Add Sensor",
            edit_field: "Edit Field",
            edit_info: "Edit Info",
            coordinate: "Coordinate",
            instant_value: "Instant",
            analysis: "Growth Analysis",
            analysis_date: "Analysis Date",
            average: "Average",
            edit_active: "Field editing active! Drag vertices. Click button again when done.",
            changes_saved: "Changes saved!",
            field_name_required: "Field name cannot be empty.",
            field_updated: "Field information updated.",
            update_error: "Error during update.",
            drawing_error: "Error during drawing"
        },
        sensor: {
            system_active: "SYSTEM ACTIVE",
            sensor: "Sensor",
            temperature: "TEMPERATURE",
            humidity: "HUMIDITY",
            soil_moisture: "SOIL MOISTURE",
            last_sync: "Last Sync",
            open_details: "OPEN DETAILED ANALYSIS"
        },
        common: {
            loading: "Loading...",
            error: "Error",
            success: "Success",
            cancel: "Cancel",
            save: "Save",
            confirm: "Confirm"
        },
        alerts: {
            map_mode_opened: "🗺️ Map mode opened!\n\n🆕 To create a new field:\n1. Use the drawing tools (Polygon or Rectangle) in the top right corner of the map.\n2. Draw your field boundaries on the map.",
            field_created: "Field created successfully!",
            field_create_error: "Error creating field:",
            select_field_first: "Please select a field first!",
            no_images_found: "No cloud-free Sentinel-2 images found for the selected area in the last year.",
            images_saved: "Images saved. Click \"Run NDVI Analysis\" button to start the process.",
            analysis_complete: "Analysis Complete!",
            analysis_error: "NDVI analysis error:",
            image_search: {
                scanning: "Scanning Sentinel-2 Satellite...",
                location: "Location",
                duration: "Duration",
                duration_text: "Last 1 Year",
                found: "TOTAL {{count}} IMAGES FOUND.",
                newest: "Newest",
                oldest: "Oldest",
                start_analysis: "Start NDVI Analysis?",
                no_images: "No cloud-free Sentinel-2 images found for the selected area in the last year.",
                please_search_first: "Please click \"Search Images\" button first to find Sentinel-2 images!",
                analysis_success: "Analysis Complete!",
                analysis_details: "🛰️ Sentinel-2 L2A (SCL Cloud Masking Applied)\n📅 Processed Images: {{count}}\n📊 Last Data: {{date}}\n📈 Avg NDVI: {{ndvi}}\n📈 Avg NDRE: {{ndre}}\n\nAnalysis data has been cleaned using SCL (Scene Classification) algorithm and cloudy pixels have been filtered.",
                no_meaningful_data: "Analysis completed but no meaningful NDVI data could be generated from the images or GEE servers did not respond.\n\nYou may try selecting a more recent date range or one with less cloud cover.",
                analysis_refreshed: "✅ Analysis refreshed! Snow/Ice data included.",
                refresh_error: "Refresh Error",
                search_error: "Image search error",
                contact_admin: "Please try again or contact the system administrator."
            }
        },
        ndvi: {
            bare_soil: "Bare soil",
            sparse_vegetation: "Sparse vegetation",
            medium_density: "Medium density",
            dense_vegetation: "Dense vegetation",
            use_ndre: "Use NDRE",
            no_data: "No Data",
            unknown: "Unknown"
        },
        ndmi: {
            critical_stress: "Critical stress",
            high_stress: "High stress",
            medium_stress: "Medium stress",
            attention: "Attention",
            light_stress: "Light stress",
            normal: "Normal",
            good: "Good",
            very_good: "Very good",
            high_moisture: "High moisture",
            no_data: "No Data",
            unknown: "Unknown"
        },
        field_details: {
            title: "Field Details",
            field_name: "Field Name",
            area_label: "Area",
            hectare: "Hectare",
            planting_date: "Planting Date",
            not_specified: "Not specified",
            current_status: "Current Status",
            last_data_date: "Last Data Date",
            avg_ndvi: "Avg. NDVI",
            avg_ndmi: "Avg. NDMI",
            avg_ndre: "Avg. NDRE",
            min_value: "Min Value",
            max_value: "Max Value"
        },
        weather: {
            humidity: "Humidity",
            wind: "Wind",
            loading: "Loading weather...",
            clear: "Clear",
            partly_cloudy: "Partly Cloudy",
            cloudy: "Cloudy",
            overcast: "Overcast",
            fog: "Foggy",
            freezing_fog: "Freezing Fog",
            light_drizzle: "Light Drizzle",
            light_rain: "Light Rain",
            rain: "Rain",
            heavy_rain: "Heavy Rain",
            light_snow: "Light Snow",
            snow: "Snow",
            heavy_snow: "Heavy Snow",
            storm: "Storm",
            unknown: "Unknown"
        },
        risk_analysis: {
            loading: "Analyzing risks...",
            title: "Risk Analysis & Recommendations",
            detected_issues: "Detected Issues",
            no_risk: "No risks detected.",
            recommendations: "Recommendations",
            detailed_stats: "Detailed Statistics",
            total_analysis: "Total Analyses",
            average: "Average",
            monitoring_period: "Monitoring Period",
            days: "days",
            area: "Area",
            data_missing: "Data Missing",
            no_analysis_for_field: "No {{index}} analysis has been performed for this field yet.",
            start_with_ndvi: "Start by running NDVI analysis",
            critical_loss: "Critical {{index}} Loss",
            sharp_decline: "A sharp decline was observed in {{index}} values recently.",
            mild_regression: "Mild Growth Regression",
            mild_slowdown: "A slight slowdown detected in index values (Trend: {{trend}}).",
            positive_trend: "Positive Growth Trend",
            growth_increasing: "Growth is showing a steady increase (+{{trend}}).",
            water_stress: "Water Stress Detected",
            water_stress_desc: "NDMI: {{value}} - Water stress or drought risk present in crops.",
            attention_mild_stress: "Attention / Mild Stress",
            mild_stress_desc: "NDMI: {{value}} - Moisture level borderline, mild stress signs possible.",
            ideal_moisture: "Ideal Moisture / Good Condition",
            ideal_moisture_desc: "NDMI: {{value}} - Plants have adequate moisture, healthy growth.",
            very_low_biomass: "Very Low Biomass",
            low_biomass_desc: "{{index}}: {{value}} - Most of the area lacks vegetation cover.",
            early_growth: "Early Growth / Low Density",
            early_growth_desc: "{{index}}: {{value}} - Vegetation has not yet reached canopy closure.",
            dense_canopy: "Dense and Healthy Canopy",
            dense_canopy_desc: "{{index}}: {{value}} - Maximum photosynthetic activity observed.",
            low_homogeneity: "Low Homogeneity",
            low_homogeneity_desc: "High growth/moisture variations within field. Localized intervention may be needed.",
            analysis_error: "Analysis Failed",
            analysis_error_desc: "An error occurred during risk analysis.",
            rec_soil_moisture_loss: "Soil moisture loss is rapid: Review irrigation schedule urgently.",
            rec_heat_stress: "Heat stress: Consider mulching or shading to reduce evaporation loss.",
            rec_field_inspection: "Urgent field inspection: Disease or pest pressure possible.",
            rec_leaf_analysis: "Leaf analysis: Evaluate potential nutrient deficiency.",
            rec_monitor_moisture: "Monitor soil moisture level and irrigation frequency.",
            rec_continue_maintenance: "Continue with the maintenance program as planned.",
            rec_check_irrigation: "Check irrigation system; urgent watering may be needed.",
            rec_monitor_closely: "Monitor moisture levels closely.",
            rec_continue_irrigation: "You may continue with the current irrigation program.",
            rec_check_emergence: "Check seed emergence success.",
            rec_weed_competition: "Monitor weed competition.",
            rec_drainage: "Check drainage or soil structure heterogeneity."
        },
        ai: {
            title: "AI Crop Advisor",
            description: "Get AI-powered analysis and recommendations using crop-specific knowledge base and satellite data.",
            analyze_button: "Start Analysis",
            analyzing: "AI is analyzing...",
            analyzing_hint: "This may take a few seconds",
            retry: "Retry",
            reanalyze: "Analyze Again",
            analysis_failed: "Analysis failed. Please try again.",
            missing_data: "Field or analysis data is missing.",
            knowledge_used: "Knowledge base used",
            open_advisor: "AI Advisor"
        },
        fieldMap: {
            modal: {
                newFieldTitle: "Save New Field",
                fieldName: "Field Name",
                namePlaceholder: "Ex: North Plot",
                cropType: "Crop Type",
                cropPlaceholder: "Ex: Wheat, Corn...",
                plantingDate: "Planting Date",
                assignUser: "Assign User (Admin)",
                assignSelf: "Assign to Myself",
                cancel: "Cancel",
                save: "Save",
                editFieldTitle: "Edit Field",
                fieldResponsible: "Field Rep (Transfer)",
                myself: "Myself",
                close: "Close",
                update: "Update"
            }
        },
        ndmiLegend: {
            title: "NDMI Value Description",
            critical: "Critical",
            highStress: "High Stress",
            mediumStress: "Medium Stress",
            attention: "Attention",
            lightStress: "Light Stress",
            normal: "Normal",
            good: "Good",
            veryGood: "Very Good",
            moist: "Moist"
        },
        ndviLegend: {
            title: "NDVI Value Description",
            bareSoil: "Bare Soil / Water",
            weakVegetation: "Weak Vegetation",
            mediumVegetation: "Medium Vegetation",
            healthyVegetation: "Healthy Vegetation",
            veryHealthyVegetation: "Very Healthy Vegetation"
        },
        trendAnalysis: {
            title: "Trend Analysis",
            firstMeasurement: "First Measurement",
            lastMeasurement: "Last Measurement",
            change: "Change",
            significantImprovement: "Significant improvement in plant health",
            stableHealth: "Plant health is stable",
            slightDecline: "Slight decline - Monitoring recommended",
            significantDecline: "Significant decline - Intervention may be needed"
        },
        sensorModal: {
            title: "Sensor Selection",
            singleSensor: "Single Sensor",
            batchAdd: "Batch Add",
            selectSensorToUpdate: "Select the sensor you want to update location:",
            selectSensorPlaceholder: "Select sensor...",
            targetField: "Target Field:",
            selectFieldFirst: "Please select a field first!",
            selectSensorsToAdd: "Select sensors to add:",
            selectAll: "Select All",
            clear: "Clear",
            addToField: "Add Sensor to Field",
            noSensorsAvailable: "No sensors available."
        },
        loadingOverlay: {
            processing: "Processing..."
        },
        report: {
            title: "FIELD ANALYSIS REPORT",
            generate: "Generate Report",
            generating: "Generating Report...",
            date: "Date",
            area: "Area",
            hectares: "hectares",
            fieldInfo: "FIELD INFORMATION",
            cropType: "Crop Type",
            location: "Location",
            analysis: "ANALYSIS",
            latestValue: "Latest Value",
            min: "Min",
            max: "Max",
            aiAnalysis: "AI ANALYSIS AND RECOMMENDATIONS"
        }
    }
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('appLanguage') || 'en';
    });

    useEffect(() => {
        localStorage.setItem('appLanguage', language);
        if (i18n.language !== language) {
            i18n.changeLanguage(language);
        }
    }, [language]);

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
    };

    const t = (path) => {
        const keys = path.split('.');
        let current = translations[language];
        for (const key of keys) {
            if (current[key] === undefined) return path;
            current = current[key];
        }
        return current;
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
